module.exports = __webpack_public_path__ + "static/media/Transcomos.64c9162f.png";